import util from './funcoes.js';

export var validadorDataHora = (rule, value, callback) => {
  if(util.validarDataHora(value)) {
    callback();
  } else {
    callback(new Error("Data/Hora inválida"));
  }
};

export var validadorHora = (rule, value, callback) => {
  if(util.validarHora(value)) {
    callback();
  } else {
    callback(new Error("Hora inválida"));
  }
};

export var validadorData = (rule, value, callback) => {
  if(rule.required) {
    if(!value) { callback(new Error("Data obrigatória")); }
    
    if(util.validarData(value)) {
      callback();
    } else {
      callback(new Error("Data inválida"));
    } 
  } else {
    if(!value) { callback(); }
    
    if(util.validarData(value)) {
      callback();
    } else {
      callback(new Error("Data inválida"));
    }
  }
};